import { CanUserCallback, CUSTOM_THEME, SETTINGS, USER, VIEW } from "src/context/FoodpilotContext";

export const canAccessSettings = (canUser: CanUserCallback) =>
    canUser(VIEW, SETTINGS) || canUser(VIEW, USER) || canUser(VIEW, CUSTOM_THEME);
